<template>
  <nav :class="classes">
    <div class="catalog-toolbar__inner">
      <div class="catalog-toolbar__group">
        <cart-badge class="catalog-toolbar__badge"/>
        <span class="catalog-toolbar__label">{{$t('sayl-oat.toolbar_title')}}</span>
      </div>

      <actions-button 
        appearance="primary"
        class="catalog-toolbar__cta" 
        icon-post="arrow-right"
        :href="{ name: 'sayl-oat-checkout.review' }"
      >{{ $n(price, 'currency') }}</actions-button>
    </div>
  </nav>
</template>

<script>
import { mapState } from 'vuex'
import CartBadge from '@/components/checkout/cart-badge'

export default {
  name: 'CatalogToolbar',

  components: {
    CartBadge
  },

  computed:{
    ...mapState({
      cart: state => state['sayl-oat'].cart,
    }),

    classes(){
      return {
        'catalog-toolbar': true,
        'container': true,
        '-is-active': this.nCartItem > 0
      }
    },

    nCartItem(){
      return this.cart ? this.cart.items.length : 0;
    },

    price() {
      return this.cart ? this.cart.total.value : 0;
    }
  }
}
</script>
